<template>
<div>
    <div v-if="buttonTop" class="mb-3">
        <b-button v-if="checkUserPermission('cbbformulier', 'can_add')" @click="addNew = !addNew" :variant="addNew ? 'danger' : 'primary'"><i :class="[addNew ? 'fa-solid fa-ban' : 'fa-solid fa-plus']"></i> {{ addNew ? 'Cancel' : 'Add' }}</b-button>
        <b-collapse id="add" v-model="addNew" variant="primary">
            <CbbFormulierForm class="mt-3" :callback="callback" :small="small" @created="addNew = false" :refresh="addNew" />
        </b-collapse>
    </div>
    <b-overlay :show="confirm" no-wrap @shown="onShown">
        <template #overlay>
            <div ref="dialog" tabindex="-1" role="dialog" aria-modal="false" aria-labelledby="form-confirm-label">
                <p class="text-center">
                    <i class="fa-light fa-xmark text-danger"></i> <strong class="text-danger">DELETE CBB FORMULIER ON {{ toLocaleDate(selected?.created) }} </strong>
                </p>
                <div class="text-center">
                    <b-button variant="outline-danger" class="mr-3" @click="onCancel">Cancel</b-button>
                    <b-button variant="outline-success" @click="onConfirmed(selected)">Confirm</b-button>
                </div>
            </div>
        </template>
    </b-overlay>
    <b-overlay
        :show="$store.getters['loading/isLoading']('cbbformulier')"
        rounded="sm"
        variant="light"
        spinner-variant="dark"
        :opacity="0.80"
        blur="2px">
        <b-card-body class="p-0">
            <b-table
                ref="table"
                class="m-0"
                responsive
                stacked="sm"
                show-empty
                striped
                hover
                :fixed="fixed"
                :small="small"
                :borderless="borderless"
                primary-key="id"
                :current-page="currentPage"
                :per-page="perPage"
                :items="items"
                :fields="fields"
                :no-sort-reset="true"
                :sort-by.sync="sortedBy"
                :sort-desc.sync="sortedDesc"
                :no-border-collapse="false">

                <template v-slot:cell(child_first_names)="data">
                    <span :class="{ 'small font-italic text-muted': !data.value }">{{ data.value || 'n/a' }} </span>
                </template>

                <template v-slot:cell(actions)="row">
                    <b-button-group size="sm">
                        <b-button v-if="checkUserPermission('cbbformulier', 'can_execute')" variant="secondary" v-b-tooltip.hover title="Print" @click="printRow(row)"><i class="fa-solid fa-print"></i></b-button>

                        <b-button variant="primary" @click="row.toggleDetails"><i class="fa-solid fa-ellipsis-h"></i></b-button>
                        <b-button v-if="checkUserPermission('cbbformulier', 'can_delete')" variant="danger" @click="onRemoveItem(row.item)"><i class="fa-light fa-xmark"></i></b-button>
                    </b-button-group>
                </template>

                <template #row-details="row">
                    <b-list-group flush>
                        <b-list-group-item><strong>Kind:</strong> {{ row.item.child_first_names || 'n/a' }} ({{ row.item.child_gender || 'n/a' }}), geboren {{ row.item.child_dob || 'n/a' }} {{ row.item.child_time || '' }} te {{ row.item.child_birth_place || 'n/a' }}</b-list-group-item>
                        <b-list-group-item><strong>Moeder:</strong> {{ row.item.mother_surname || 'n/a' }}, {{ row.item.mother_first_names || 'n/a' }}</b-list-group-item>
                        <b-list-group-item><strong>Vader:</strong> {{ row.item.father_surname || 'n/a' }}, {{ row.item.father_first_names || 'n/a' }}</b-list-group-item>
                        <b-list-group-item><strong>Verlosk:</strong> {{ row.item.midwife || 'n/a' }}</b-list-group-item>
                    </b-list-group>
                </template>

                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>

                <template v-slot:empty="scope">
                    <div class="small text-muted text-center my-2">
                        <span>n/a</span>
                    </div>
                </template>
                <template v-slot:custom-foot="scope">
                    <b-tr class="border-top">
                        <b-td colspan="1" class="align-middle" variant="light" style="background: #fff;">
                            Showing {{ startIndex }} to {{ endIndex }} of {{ totalRows }}
                        </b-td>
                        <b-td colspan="1" class="text-right align-middle" variant="light" style="background: #fff;">
                            <b-pagination class="m-0" prev-text="Prev" next-text="Next" hide-goto-end-buttons align="right" :total-rows="totalRows" v-model="currentPage" :per-page="perPage" />
                        </b-td>
                    </b-tr>
                </template>
            </b-table>
            <b-card-footer v-if="!buttonTop">
                <b-button v-if="checkUserPermission('cbbformulier', 'can_add')" @click="addNew = !addNew" :variant="addNew ? 'danger' : 'primary'"><i :class="[addNew ? 'fa-solid fa-ban' : 'fa-solid fa-plus']"></i> {{ addNew ? 'Cancel' : 'Add' }}</b-button>
                <b-collapse id="add" v-model="addNew" variant="primary">
                    <CbbFormulierForm class="mt-3" :callback="callback" :small="small" @created="addNew = false" :refresh="addNew"/>
                </b-collapse>
            </b-card-footer>
        </b-card-body>
    </b-overlay>
</div>
</template>
<script>
import ComponentBaseExtension from "@/core/components/ComponentBaseExtension"
import { mapGetters, mapActions } from "vuex"

import CbbFormulierForm from './CbbFormulierForm'

import printJS from 'print-js'
import cloneDeep from 'lodash/cloneDeep'

export default ComponentBaseExtension.extend({
    name: "cbbformulier-base",
    components: {
        CbbFormulierForm
    },
    data() {
        return {
            addNew: false,
            fields: [
                { key: 'cbbformulier_date', label: 'Date/Time', class: {"align-middle" : true, "small": this.small }, formatter: (value) => this.toLocaleDate(value) },
                { key: 'child_first_names', label: 'Kind', class: {"align-middle" : true, "small": this.small } },
                { key: "actions", label: "", class: {"align-middle" : true, "text-right": true, "small": this.small } },
            ],

            currentPage: 1,
            perPage: 5,
            sortedBy: 'cbbformulier_date',
            sortedDesc: true,

            confirm: false,
            selected: null,
        }
    },
    computed: {
        ...mapGetters('health', ['getPatientCbbFormulier']),
        items() {
            return cloneDeep(this.getPatientCbbFormulier())
        },
        totalRows() {
            return this.items.length
        },
        startIndex() {
            return (this.currentPage - 1) * this.perPage + 1
        },
        endIndex() {
            var end = this.totalRows
            if (this.perPage < this.totalRows) {
                end = this.perPage * this.currentPage
                if (end > this.totalRows) {
                    end = this.totalRows
                }
            }
            return end
        }
    },
    methods: {
        ...mapActions('health', ['getCbbFormulierForCurrentPatient', 'deletePatientCbbFormulier', 'cbbformulierToHTMLById']),
        async loadForPatient(patient) {
            await this.getCbbFormulierForCurrentPatient()
        },
        async printRow(row) {
            const cbbformulier = await this.cbbformulierToHTMLById(row.item.id)
            printJS({
                printable: cbbformulier,
                type: 'raw-html'
            })
        },
        onRemoveItem(item) {
            this.confirm = true
            this.selected = item
        },
        onConfirmed(item) {
            this.deletePatientCbbFormulier(item.id).then(() => {
                this.notify("CBB formulier removed", "CBB formulier was removed successfully")
                this.confirm = false
                this.processing = false
                this.selected = null
            })
            .catch(errors => {
                this.notify("Error", "Something went wrong", 'danger')
                this.confirm = false
                this.selected = null
            })
        },
        onShown() {
            this.$refs.dialog?.focus()
        },
        onCancel() {
            this.confirm = false
            this.selected = null
        }
    }
})
</script>
